import React, { useState } from 'react';
import { useAuth, API } from '../App';
import { Mail, X, RefreshCw, ShieldAlert } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

export const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Don't show if verified, dismissed, or no user
  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      const res = await axios.post(`${API}/auth/resend-verification`);
      if (res.data?.success) {
        toast.success('Verification email sent! Check your inbox.');
      } else {
        toast.error(res.data?.message || 'Failed to send verification email');
      }
    } catch (err) {
      toast.error('Failed to send verification email. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="email-verification-banner"
      className="bg-amber-50 border-b border-amber-200 px-4 py-3 flex items-center justify-between gap-3"
    >
      <div className="flex items-center gap-2.5 min-w-0">
        <ShieldAlert className="w-5 h-5 text-amber-600 flex-shrink-0" />
        <div className="text-sm text-amber-800 min-w-0">
          <span className="font-semibold">Verify your email to unlock all features.</span>
          <span className="hidden sm:inline"> Check your inbox or </span>
          <span className="sm:hidden"> </span>
          <button
            data-testid="resend-verification-btn"
            onClick={handleResend}
            disabled={sending}
            className="inline-flex items-center gap-1 font-bold text-amber-900 underline underline-offset-2 hover:text-amber-700 disabled:opacity-50"
          >
            {sending && <RefreshCw className="w-3 h-3 animate-spin" />}
            {sending ? 'sending...' : 'resend verification email'}
          </button>
        </div>
      </div>
      <button
        data-testid="dismiss-verification-banner"
        onClick={() => setDismissed(true)}
        className="text-amber-400 hover:text-amber-600 flex-shrink-0 p-0.5"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
